/*
Copyright 2024 New Vector Ltd.
Copyright 2022 The Matrix.org Foundation C.I.C.

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

export const ReadPinsEventId = "im.vector.room.read_pins";

declare module "matrix-js-sdk/src/types" {
    interface RoomAccountDataEvents {
        [ReadPinsEventId]: { event_ids: string[] };
    }
}
